import { helper, only_when_authorised } from '@phi/frontend/api';

export const searchDocuments = only_when_authorised(helper('searchDocuments'));
